// Sticky Add to Cart — desktop + mobile PDP (Dawn-compatible)
(function () {
  if (window.__productStickyAtcInit) return;
  window.__productStickyAtcInit = true;

  function formatMoney(cents, moneyFormat) {
    const value = Number(cents || 0) / 100;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      try {
        return Shopify.formatMoney(cents, moneyFormat);
      } catch (e) {
        // fall through
      }
    }

    return 'Rs.' + value.toLocaleString('en-PK') + ' PKR';
  }

  function getMainForm(bar) {
    const formId = bar.getAttribute('data-form-id');
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId) return byId;
    }
    return document.querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function getMainSubmit(form) {
    if (!form) return null;
    return (
      form.querySelector('[type="submit"][name="add"]') ||
      document.querySelector(`#ProductSubmitButton-${form.closest('product-form')?.dataset?.sectionId || ''}`) ||
      form.querySelector('[type="submit"]') ||
      document.querySelector('.product-form__submit')
    );
  }

  function getMainQtyInput(form) {
    if (!form) return null;
    const formId = form.id;
    return (
      document.querySelector(`quantity-input input[form="${formId}"]`) ||
      document.querySelector(`#Quantity-${form.closest('[data-section]')?.dataset?.section || ''}`) ||
      document.querySelector('.pdp-cta .quantity__input') ||
      form.querySelector('input[name="quantity"]')
    );
  }

  function syncQtyFromMain(bar, form) {
    const stickyInput = bar.querySelector('[data-psatc-qty-input]');
    const mainQty = getMainQtyInput(form);
    if (!stickyInput || !mainQty) return;
    stickyInput.value = mainQty.value || stickyInput.value || '1';
    stickyInput.min = mainQty.min || '1';
    if (mainQty.max) stickyInput.max = mainQty.max;
  }

  function syncQtyToMain(bar, form, value) {
    const mainQty = getMainQtyInput(form);
    const stickyInput = bar.querySelector('[data-psatc-qty-input]');
    const next = Math.max(1, parseInt(value, 10) || 1);
    if (stickyInput) stickyInput.value = String(next);
    if (mainQty) {
      mainQty.value = String(next);
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncSelectedOptions(bar) {
    const sectionId = bar.getAttribute('data-section-id');
    const variantSelects =
      document.getElementById(`variant-selects-${sectionId}`) || document.querySelector('variant-selects');

    if (!variantSelects) return;

    variantSelects.querySelectorAll('.product-form__input').forEach((group, index) => {
      const position = index + 1;
      const valueEl = bar.querySelector(`[data-psatc-option-value="${position}"]`);
      if (!valueEl) return;

      const selectedValueEl = group.querySelector('[data-selected-value]');
      if (selectedValueEl?.textContent.trim()) {
        valueEl.textContent = selectedValueEl.textContent.trim();
        return;
      }

      const checkedInput = group.querySelector('input[type="radio"]:checked');
      if (checkedInput?.value) {
        valueEl.textContent = checkedInput.value;
        return;
      }

      const select = group.querySelector('select');
      if (select?.value) {
        valueEl.textContent = select.value;
      }
    });
  }

  function updateBarFromVariant(bar, variant) {
    const priceEl = bar.querySelector('[data-psatc-price]');
    const compareEl = bar.querySelector('[data-psatc-compare]');
    const variantEl = bar.querySelector('[data-psatc-variant]');
    const imgEl = bar.querySelector('[data-psatc-image]');
    const btn = bar.querySelector('[data-psatc-add]');
    const btnText = bar.querySelector('[data-psatc-add-text]');
    if (!btn || !btnText) return;

    const moneyFormat = bar.getAttribute('data-money-format') || '';
    const strings = {
      add: btn.getAttribute('data-default-text') || 'Add to cart',
      soldOut: btn.getAttribute('data-sold-out-text') || 'Sold out',
      unavailable: btn.getAttribute('data-unavailable-text') || 'Unavailable',
    };

    if (!variant) {
      btn.disabled = true;
      btn.classList.add('disabled');
      btnText.textContent = strings.unavailable;
      return;
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price, moneyFormat);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
      }
    }

    if (variant.options?.length) {
      variant.options.forEach((value, index) => {
        const valueEl = bar.querySelector(`[data-psatc-option-value="${index + 1}"]`);
        if (valueEl && value) valueEl.textContent = value;
      });
    } else if (variant.option1 || variant.option2 || variant.option3) {
      [variant.option1, variant.option2, variant.option3].forEach((value, index) => {
        if (!value) return;
        const valueEl = bar.querySelector(`[data-psatc-option-value="${index + 1}"]`);
        if (valueEl) valueEl.textContent = value;
      });
    }

    syncSelectedOptions(bar);

    if (variantEl) {
      variantEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    }

    if (imgEl) {
      const media = variant.featured_media || variant.featured_image;
      const url = media?.preview_image?.src || media?.src || '';
      if (url) {
        imgEl.src = url.includes('width=') ? url : `${url}${url.includes('?') ? '&' : '?'}width=144`;
        const alt = media.alt || media.preview_image?.alt;
        if (alt) imgEl.alt = alt;
      }
    }

    if (variant.available) {
      btn.disabled = false;
      btn.classList.remove('disabled');
      btnText.textContent = strings.add;
    } else {
      btn.disabled = true;
      btn.classList.add('disabled');
      btnText.textContent = strings.soldOut;
    }
  }

  function updateBarFromMainButton(bar, mainBtn) {
    const btn = bar.querySelector('[data-psatc-add]');
    const btnText = bar.querySelector('[data-psatc-add-text]');
    if (!btn || !btnText || !mainBtn) return;

    const disabled = mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true';
    btn.disabled = disabled;
    btn.classList.toggle('disabled', disabled);

    const mainText = mainBtn.querySelector('span:not(.sold-out-message):not(.loading-overlay__spinner):not(.visually-hidden)');
    if (mainText && mainText.textContent.trim()) {
      btnText.textContent = mainText.textContent.trim();
    }
  }

  function setLoading(bar, isLoading) {
    const stickyBtn = bar.querySelector('[data-psatc-add]');
    if (!stickyBtn) return;
    stickyBtn.classList.toggle('psatc__add--loading', isLoading);
  }

  function getErrorMessageFromEvent(event) {
    if (!event) return '';

    const data = event.data || event;
    const candidates = [];

    if (typeof data.description === 'string' && data.description.trim()) {
      candidates.push(data.description.trim());
    }

    const errors = data.errors;
    if (typeof errors === 'string' && errors.trim()) {
      candidates.push(errors.trim());
    } else if (Array.isArray(errors)) {
      candidates.push(
        errors
          .map((item) => (typeof item === 'string' ? item : item?.message || item?.description || ''))
          .filter(Boolean)
          .join(' ')
      );
    } else if (errors && typeof errors === 'object') {
      candidates.push(
        Object.values(errors)
          .flat()
          .map((item) => (typeof item === 'string' ? item : ''))
          .filter(Boolean)
          .join(' ')
      );
    }

    if (typeof data.message === 'string' && data.message.trim()) {
      candidates.push(data.message.trim());
    }

    // Prefer the most useful message (skip generic "Cart Error" when better text exists)
    const useful = candidates.find(
      (text) => text && text.toLowerCase() !== 'cart error' && text.toLowerCase() !== 'error'
    );

    return useful || candidates.find(Boolean) || '';
  }

  function getMainFormErrorText(form) {
    const productForm = form?.closest('product-form') || document.querySelector('product-form');
    const errorEl = productForm?.querySelector('.product-form__error-message');
    const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');
    if (!errorEl || !wrapper || wrapper.hasAttribute('hidden')) return '';
    return errorEl.textContent.trim();
  }

  function showStickyError(bar, message) {
    const errorBox = bar.querySelector('[data-psatc-error]');
    const errorText = bar.querySelector('[data-psatc-error-text]');
    if (!errorBox || !errorText || !message) return;

    errorText.textContent = message;
    errorBox.hidden = false;
    bar.classList.add('psatc--has-error');
    document.documentElement.style.setProperty('--psatc-height', `${bar.offsetHeight}px`);
  }

  function clearStickyError(bar) {
    const errorBox = bar.querySelector('[data-psatc-error]');
    const errorText = bar.querySelector('[data-psatc-error-text]');
    if (!errorBox || !errorText) return;

    errorText.textContent = '';
    errorBox.hidden = true;
    bar.classList.remove('psatc--has-error');
    document.documentElement.style.setProperty('--psatc-height', `${bar.offsetHeight}px`);
  }

  function setupBar(bar) {
    if (bar.dataset.psatcReady === 'true') return;

    const form = getMainForm(bar);
    const mainBtn = getMainSubmit(form);
    if (!form || !mainBtn) return;

    bar.dataset.psatcReady = 'true';
    const stickyBtn = bar.querySelector('[data-psatc-add]');
    const qtyInput = bar.querySelector('[data-psatc-qty-input]');
    const qtyDecrease = bar.querySelector('[data-psatc-qty-decrease]');
    const qtyIncrease = bar.querySelector('[data-psatc-qty-increase]');

    function setBarHeight() {
      document.documentElement.style.setProperty('--psatc-height', `${bar.offsetHeight}px`);
    }

    function setVisible(show) {
      const cartOpen =
        document.querySelector('cart-drawer')?.classList.contains('active') ||
        document.body.classList.contains('overflow-hidden');
      const shouldShow = Boolean(show) && !cartOpen;

      bar.classList.toggle('psatc--visible', shouldShow);
      bar.classList.toggle('psatc--suppressed', cartOpen);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-atc', shouldShow);
      if (shouldShow) {
        setBarHeight();
      } else {
        document.body.classList.remove('has-sticky-atc');
      }
    }

    function syncCartSuppressed() {
      const cartDrawer = document.querySelector('cart-drawer');
      const isOpen =
        cartDrawer?.classList.contains('active') ||
        document.body.classList.contains('overflow-hidden');
      bar.classList.toggle('psatc--suppressed', isOpen);
      if (isOpen) {
        setLoading(bar, false);
        document.body.classList.remove('has-sticky-atc');
      } else if (bar.classList.contains('psatc--visible')) {
        document.body.classList.add('has-sticky-atc');
        setBarHeight();
      }
    }

    // Show sticky bar once main ATC leaves the viewport
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            setVisible(!entry.isIntersecting);
          });
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '0px 0px -12px 0px',
        }
      );
      observer.observe(mainBtn);
    } else {
      const onScroll = () => {
        const rect = mainBtn.getBoundingClientRect();
        setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    stickyBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const liveMainBtn = getMainSubmit(form) || document.querySelector(`#ProductSubmitButton-${bar.getAttribute('data-section-id')}`) || mainBtn;
      if (stickyBtn.disabled || liveMainBtn.disabled || liveMainBtn.getAttribute('aria-disabled') === 'true') return;

      clearStickyError(bar);
      syncQtyToMain(bar, form, qtyInput?.value || 1);
      setLoading(bar, true);

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(liveMainBtn);
      } else {
        liveMainBtn.click();
      }
    });

    qtyDecrease?.addEventListener('click', () => {
      clearStickyError(bar);
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      syncQtyToMain(bar, form, next);
    });

    qtyIncrease?.addEventListener('click', () => {
      clearStickyError(bar);
      const next = (parseInt(qtyInput.value, 10) || 1) + 1;
      syncQtyToMain(bar, form, next);
    });

    qtyInput?.addEventListener('change', () => {
      clearStickyError(bar);
      syncQtyToMain(bar, form, qtyInput.value);
    });

    const mainQty = getMainQtyInput(form);
    mainQty?.addEventListener('change', () => {
      clearStickyError(bar);
      syncQtyFromMain(bar, form);
    });
    syncQtyFromMain(bar, form);

    // Sync with Dawn variant changes
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = bar.getAttribute('data-section-id');
        if (event?.data?.sectionId && sectionId && String(event.data.sectionId) !== String(sectionId)) return;
        clearStickyError(bar);
        updateBarFromVariant(bar, event?.data?.variant);
        updateBarFromMainButton(bar, mainBtn);
        syncQtyFromMain(bar, form);
      });

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
        clearStickyError(bar);
        syncSelectedOptions(bar);
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearStickyError(bar);
        setLoading(bar, false);
      });

      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        setLoading(bar, false);
        const message =
          getErrorMessageFromEvent(event) ||
          getMainFormErrorText(form) ||
          'Unable to add this item to cart.';
        showStickyError(bar, message);
      });
    }

    // Keep sticky error in sync if main form error DOM updates
    const productForm = form.closest('product-form');
    const mainErrorWrapper = productForm?.querySelector('.product-form__error-message-wrapper');
    const mainErrorText = productForm?.querySelector('.product-form__error-message');
    if (mainErrorWrapper && mainErrorText) {
      const errorObserver = new MutationObserver(() => {
        if (mainErrorWrapper.hasAttribute('hidden')) {
          // Don't clear sticky if it already shows a message from pubsub
          // unless main form intentionally cleared the error.
          if (!mainErrorText.textContent.trim()) clearStickyError(bar);
          return;
        }

        const message = mainErrorText.textContent.trim();
        if (message) {
          setLoading(bar, false);
          showStickyError(bar, message);
        }
      });

      errorObserver.observe(mainErrorWrapper, {
        attributes: true,
        attributeFilter: ['hidden'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    form.addEventListener('submit', () => {
      clearStickyError(bar);
    });

    // Fallback sync if button text/disabled changes after section morph
    const buttonObserver = new MutationObserver(() => {
      updateBarFromMainButton(bar, mainBtn);
      setLoading(bar, mainBtn.classList.contains('loading'));
    });
    buttonObserver.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
    });

    // Suppress while cart drawer is open — also clear body padding gap
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const cartObserver = new MutationObserver(() => {
        syncCartSuppressed();
      });
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    let lastBodyOverflowHidden = document.body.classList.contains('overflow-hidden');
    const bodyObserver = new MutationObserver(() => {
      const isOverflowHidden = document.body.classList.contains('overflow-hidden');
      if (isOverflowHidden === lastBodyOverflowHidden) return;
      lastBodyOverflowHidden = isOverflowHidden;
      syncCartSuppressed();
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', () => {
      if (bar.classList.contains('psatc--visible') && !bar.classList.contains('psatc--suppressed')) {
        setBarHeight();
      }
    });
    syncSelectedOptions(bar);
    updateBarFromMainButton(bar, mainBtn);
  }

  function init() {
    document.querySelectorAll('[data-product-sticky-atc]').forEach((bar) => {
      if (bar.closest('quick-add-modal')) return;
      setupBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
